document.querySelectorAll('.cbs').forEach(function (cbs) {
  const track = cbs.querySelector('.cbs__track');
  const slides = Array.from(cbs.querySelectorAll('.cbs__slide'));
  const dotsWrap = cbs.querySelector('.cbs__dots');
  const ring = cbs.querySelector('.cbs__ring-fg');
  const curEl = cbs.querySelector('.cbs__cur');
  const totalEl = cbs.querySelector('.cbs__total');
  const arrows = Array.from(cbs.querySelectorAll('.cbs__arrow'));
  const anim = cbs.dataset.animation;
  const autoplay = cbs.dataset.autoplay === 'true';
  const parallax = cbs.dataset.parallax === 'true';
  const speed = (parseInt(cbs.dataset.speed, 10) || 6) * 1000;
  let index = 0, timer;

  const pad = n => String(n + 1).padStart(2, '0');
  if (totalEl) totalEl.textContent = pad(slides.length - 1);

  // Split headings into lines for kinetic reveal
  slides.forEach(slide => {
    const h = slide.querySelector('[data-reveal-lines]');
    if (h) {
      const words = h.textContent.trim();
      h.innerHTML = `<span class="cbs__line"><span>${words}</span></span>`;
    }
  });

  if (slides.length <= 1) {
    cbs.querySelectorAll('.cbs__arrow, .cbs__ring').forEach(el => el.style.display = 'none');
    slides[0] && slides[0].classList.add('is-active');
  }

  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.addEventListener('click', () => goTo(i));
    dotsWrap.appendChild(dot);
  });
  const dots = Array.from(dotsWrap.children);

  function runRing() {
    if (!autoplay || !ring) return;
    ring.classList.remove('run');
    ring.style.transitionDuration = '0ms';
    ring.style.strokeDashoffset = '126';
    void ring.offsetWidth; // reflow
    ring.style.transitionDuration = speed + 'ms';
    ring.classList.add('run');
    ring.style.strokeDashoffset = '0';
  }

  function render() {
    if (anim === 'slide') track.style.transform = `translateX(-${index * 100}%)`;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    if (curEl) curEl.textContent = pad(index);
    runRing();
  }
  function goTo(i) { index = (i + slides.length) % slides.length; render(); restart(); }
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);
  function restart() { if (!autoplay || slides.length <= 1) return; clearInterval(timer); timer = setInterval(next, speed); }

  // Cursor follow (fine pointers only)
  if (window.matchMedia('(pointer:fine)').matches) {
    slides.forEach(slide => {
      const cur = slide.querySelector('.cbs__cursor');
      if (!cur) return;
      slide.addEventListener('mousemove', e => {
        const r = slide.getBoundingClientRect();
        cur.style.setProperty('--cx', (e.clientX - r.left) + 'px');
        cur.style.setProperty('--cy', (e.clientY - r.top) + 'px');
        slide.classList.add('cbs__cursor-active');
      });
      slide.addEventListener('mouseleave', () => slide.classList.remove('cbs__cursor-active'));
    });

    // Hide the cursor label while pointer is over an arrow
    arrows.forEach(arrow => {
      arrow.addEventListener('mouseenter', () => slides[index].classList.add('cbs__cursor-hidden'));
      arrow.addEventListener('mouseleave', () => slides[index].classList.remove('cbs__cursor-hidden'));
    });
  }

  if (slides.length <= 1) { render(); return; }

  cbs.querySelector('.cbs__arrow--next').addEventListener('click', next);
  cbs.querySelector('.cbs__arrow--prev').addEventListener('click', prev);

  // Pause on hover
  cbs.addEventListener('mouseenter', () => {
    clearInterval(timer);
    if (ring) { const cs = getComputedStyle(ring); ring.style.transitionDuration = '0ms'; ring.style.strokeDashoffset = cs.strokeDashoffset; }
  });
  cbs.addEventListener('mouseleave', restart);

  // Swipe
  let startX = 0;
  track.addEventListener('touchstart', e => startX = e.touches[0].clientX, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) dx < 0 ? next() : prev();
  });

  // Keyboard
  cbs.setAttribute('tabindex', '0');
  cbs.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });

  // Mouse parallax on active media
  if (parallax && window.matchMedia('(pointer:fine)').matches) {
    cbs.addEventListener('mousemove', e => {
      const r = cbs.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      const active = slides[index].querySelector('[data-parallax-layer]');
      if (active) active.style.transform = `translate(${x * -18}px, ${y * -18}px) scale(1.04)`;
    });
    cbs.addEventListener('mouseleave', () => {
      const active = slides[index].querySelector('[data-parallax-layer]');
      if (active) active.style.transform = '';
    });
  }

  render();
  restart();
});